import React from 'react';
import { styled } from '@this/src/components/constants/themes';
import type Transit from '@this/src/domain/transit/transit';
import type SelectStore from '../../../../../domain/select_store';
import IndividualList from '../short_distance/individual/IndividualList';
import PackageList from '../short_distance/package/PackageList';

interface TransportBoxShortDistanceListContainerProps {
  transit: Transit;
  selected: boolean;
  domesticAirPriceIndex: number;
  loading: boolean;
  store: SelectStore;
  handleDomesticAirPriceChange: (index: number) => void;
  handleChange: () => void;
}

const TransportBoxShortDistanceListContainer: React.FC<TransportBoxShortDistanceListContainerProps> = ({
  transit,
  selected,
  domesticAirPriceIndex,
  loading,
  handleDomesticAirPriceChange,
  handleChange,
  store
}) => {
  return (
    <StyledBoxShortDistance selected={selected}>
      {transit.segments.map((s, i) => {
        return transit.package ? (
          <PackageList
            key={i.toString()}
            transport={transit}
            selected={selected}
            loading={loading}
            handleChange={handleChange}
            store={store}
            segment={s}
            segmentIdx={i}
          />
        ) : (
          <IndividualList
            key={i.toString()}
            loading={loading}
            transport={transit}
            selected={selected}
            handleDomesticAirPriceChange={handleDomesticAirPriceChange}
            domesticAirPriceIndex={domesticAirPriceIndex}
            handleChange={handleChange}
            segment={s}
            segmentIdx={i}
          />
        );
      })}
    </StyledBoxShortDistance>
  );
};

const StyledBoxShortDistance = styled.div<{ selected: boolean }>`
  display: flex;
  background: white;
  margin-bottom: 10px;
  font-size: 10px;

  ${props =>
    props.selected &&
    `
    border: 2px solid #eee;
    border-color: ${props.theme.linkColor}
  `};
`;

export default TransportBoxShortDistanceListContainer;
